import { AbstractControl, ValidatorFn } from '@angular/forms';
// @dynamic
export class NumberValidator {
  public static validatorNumberGreaterThanZero(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value === '' || control.value === undefined) {
        return null;
      } else if (control.value !== null) {
        const numberWithoutSpaces = control.value.toString().replace(/ /g, '');
        if (+numberWithoutSpaces === 0) {
          return { validatorNumberGreaterThanZero: true };
        }
      } else {
        return null;
      }
    };
  }

  /**
   *
   * @returns (control:AbstractControl)=>{}
   */
  // Tests if a number is negative or not. Returns true in case of negative numbers
  public validatorNumberNegative(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value === null || +control.value === 0) {
        return null;
      } else {
        const numberWithoutSpaces = control.value
          .toString()
          .replace(/ /g, '')
          .replace(',', '.');
        if (+numberWithoutSpaces >= 0) {
          return null;
        } else {
          return { validatorNumberNegative: true };
        }
      }
    };
  }

  // Tests if a number is a valid percentage value (between 0 and 100)
  public validatorNumberValidPercentage(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value == null) {
        return null;
      }
      const numberWithoutComma = control.value.toString().replace(',', '.');
      if (+numberWithoutComma >= 0 && +numberWithoutComma <= 100) {
        return null;
      } else if (+control.value >= 0 && +control.value <= 100) {
        return null;
      } else {
        return { validatorNumberValidPercentages: true };
      }
    };
  }

  /*
 tests if a number is not an integer(it contains another characters than digits and -).
   If the number is not an integer, it will return true.
   Also tests if a number starts with 0. If the number starts with 0 -> return true
*/
  public validatorNumberInteger(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value === '' || control.value === undefined) {
        return null;
      } else if (+control.value === 0) {
        return null;
      } else if (control.value !== null) {
        const numberWithoutSpaces = control.value.toString().replace(/ /g, '');
        const myRegexNoDecimal = new RegExp(/^-?^[1-9]\d*$/, 'i');
        if (!myRegexNoDecimal.test(numberWithoutSpaces)) {
          return { validatorNumberInteger: true };
        }
      } else {
        return null;
      }
    };
  }

  // tests if a number is lesser than another number
  public validatorNumberLesserThanAnother(anotherValue: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value === null) {
        return null;
      } else {
        const numberWithoutSpaces = control.value
          .toString()
          .replace(/ /g, '')
          .replace(',', '.');
        if (+numberWithoutSpaces <= anotherValue) {
          return null;
        } else {
          return { validatorNumberLesserThanAnother: true };
        }
      }
    };
  }

  // tests if a number is MAX than another number
  public validatorNumberMaxThanAnother(anotherValue: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value === null) {
        return null;
      } else {
        const numberWithoutSpaces = control.value
          .toString()
          .replace(/ /g, '')
          .replace(',', '.');
        if (+numberWithoutSpaces > anotherValue) {
          return null;
        } else {
          return { validatorNumberLesserThanAnother: true };
        }
      }
    };
  }

  constructor() {}
}
